import React from 'react';
import { spamHeuristic } from '../../lib/mailCategories';

/** Aviso en la fila (bug 4): el posible spam se queda en Principales —no se mueve a Spam solo— y se
 *  marca a la vista. Antes decía «Spam», como si ya estuviera allí. */
export default function AvisoPosibleSpam({ m }) {
  const spam = spamHeuristic(m);
  if (!spam.likely) return null;
  return (
    <span className="gmail-spam-badge" title={spam.reasons.length ? spam.reasons.join(', ') : undefined} data-testid="aviso-posible-spam">
      Posible spam
    </span>
  );
}
